import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { installGlobalErrorReporting } from './components/ErrorBoundary'
import { pruneOldVersions } from './lib/storage'
import './i18n'
import './styles/global.css'

/* Boot. */

function boot(): void {
  installGlobalErrorReporting()
  pruneOldVersions()

  const container = document.getElementById('root')
  if (container === null) throw new Error('#root is missing from index.html')

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

boot()
